import { render, staticRenderFns } from "./searchgoods.vue?vue&type=template&id=4021f194&scoped=true"
import script from "./searchgoods.vue?vue&type=script&lang=js"
export * from "./searchgoods.vue?vue&type=script&lang=js"
import style0 from "./searchgoods.vue?vue&type=style&index=0&id=4021f194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021f194",
  null
  
)

export default component.exports